export default "__VITE_ASSET__BRcMaJa6__"